<template>
  <div>
    <v-alert
      v-if="progressMsg"
      type="info"
      class="mb-n12 mx-4 mt-4"
      text
      dismissible
    >
      {{ progressMsg }}
    </v-alert>
    <v-container
      fluid
      :class="{
        'mx-12': !mobile,
        'my-6': !mobile
      }"
    >
      <div
        :class="{
          'd-flex': true,
          'flex-row': !mobile,
          'flex-column': mobile,
          'mb-4': !mobile
        }"
      >
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-cash-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Payments</p>
        </div>
        <div v-if="!mobile" class="flex-grow-1"></div>
        <div
          :class="{
            'd-flex': true,
            'flex-row': true,
            'justify-space-between': mobile,
            'mb-4': mobile
          }"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :small="mobile"
                depressed
                rounded
                color="primary"
                :class="{
                  'mr-2': !mobile,
                  'mr-1': mobile,
                  'font-weight-bold': true
                }"
                :disabled="!paidpaymentAccess.create"
                @click="openCreateMultiplePaymentsDialog"
                v-on="on"
              >
                <v-icon :small="mobile" :class="{ 'pr-1': !mobile }"
                  >mdi-file-upload</v-icon
                >Import File
              </v-btn>
            </template>
            <p style="color: white">
              Create batch payments by uploading a CSV File
            </p>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :small="mobile"
                :class="{ 'ml-1': mobile, 'font-weight-bold': true }"
                depressed
                rounded
                color="primary"
                :disabled="!paymentAccess.report"
                @click="openGenerateReportDialog"
                v-on="on"
              >
                <v-icon :small="mobile" :class="{ 'pr-1': !mobile }"
                  >mdi-file-table</v-icon
                >Generate Report
              </v-btn>
            </template>
            <p style="color: white">
              Download the transactions as an Excel-compatible CSV file
            </p>
          </v-tooltip>
        </div>
      </div>
      <v-row class="mb-0">
        <v-col class="py-0" cols="12" sm="12" md="4">
          <v-text-field
            v-model="searchString"
            solo
            flat
            append-icon="mdi-magnify"
            label="Search Tenant/Unit"
            hide-details
            class="mb-6"
            :dense="mobile"
            @click:append="searchAction"
            @keydown.enter="searchAction"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="8"
          sm="8"
          md="3"
          :class="{
            'py-0': true,
            'd-flex': mobile,
            'align-center': mobile
          }"
        >
          <v-select
            v-model="selectedCategories"
            solo
            flat
            hide-details
            label="Select Categories"
            :items="categories"
            multiple
            :dense="mobile"
            @change="searchAction"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllCategoriesAndReload">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedCategories.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{
                      iconSelected(
                        allCategoriesSelected,
                        someCategoriesSelected
                      )
                    }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ selectedCategories.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col
          cols="4"
          sm="4"
          md="3"
          :class="{
            'py-0': true,
            'd-flex': mobile,
            'align-center': mobile,
            'justify-center': mobile
          }"
        >
          <v-select
            v-model="selectedStatuses"
            solo
            flat
            hide-details
            label="Select Status"
            :items="statusItems"
            :dense="mobile"
            multiple
            @change="searchAction"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllStatusesAndReload">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedStatuses.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ iconStatuses }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ selectedStatuses.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col
          cols="8"
          sm="8"
          md="2"
          :class="{
            'py-0': true,
            'd-flex': mobile,
            'align-center': mobile
          }"
        >
          <v-select
            v-model="selectedTags"
            solo
            flat
            hide-details
            label="Select Tags"
            :items="propertyTags"
            multiple
            :dense="mobile"
            @change="searchAction"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllTags">
                <v-list-item-action>
                  <v-icon
                    :color="selectedTags.length > 0 ? 'indigo darken-4' : ''"
                    >{{
                      iconSelected(allTagsSelected, someTagsSelected)
                    }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ selectedTags.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-card
        v-if="paymentAccess.read"
        v-show="!loading"
        elevation="0"
        class="card-container px-8 py-4"
      >
        <div v-if="!mobile">
          <v-data-table
            class="denser"
            :search="searchString"
            :headers="headers"
            :items="payments"
            :options.sync="options"
            :server-items-length="total"
            item-key="refNo"
            :loading="loading"
            loading-text="Loading... Please wait"
            no-data-text="All Payments and Transactions will appear here."
            multi-sort
            :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
            dense
            :expanded.sync="expandedPayments"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <tr
                v-for="(paymentDetailItem, expandIndex) in item.payment_details"
                :key="`expand_${paymentDetailItem.refNo}_${generateId()}`"
                :class="expandedItemRow(expandIndex, item.payment_details)"
                @click="showPayment(paymentDetailItem)"
              >
                <td></td>
                <td>
                  <p class="caption">{{ paymentDetailItem.refNo }}</p>
                </td>
                <td>
                  <p class="caption">{{ paymentDetailItem.date }}</p>
                </td>
                <td class="text-overflow">
                  <a class="caption" @click="redirectBed(item)">{{
                    item.tenantName
                  }}</a>
                </td>
                <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
                <td>
                  <p class="caption">{{ paymentDetailItem.category }}</p>
                </td>
                <td>
                  <p class="caption">{{ paymentDetailItem.period }}</p>
                </td>
                <td>
                  <p class="caption">{{ paymentDetailItem.dueDate }}</p>
                </td>
                <td>
                  <p class="caption">
                    {{ formatCurrency(paymentDetailItem.total) }}
                  </p>
                </td>
                <td>
                  <p class="caption">
                    {{
                      formatCurrency(
                        paymentDetailItemAmountPaid(
                          paymentDetailItem,
                          item.paidPaymentId
                        )
                      )
                    }}
                  </p>
                </td>
                <td>
                  <p :class="statusClass(paymentDetailItem.raw_status)">
                    {{ paymentDetailItem.status }}
                  </p>
                </td>
                <td>
                  <div class="d-flex flex-row">
                    <v-tooltip
                      v-if="
                        paymentDetailItem.status &&
                        (paymentDetailItem.raw_status ===
                          PaymentStatus.PENDING ||
                          paymentDetailItem.raw_status ===
                            PaymentStatus.PAID_PARTIAL) &&
                        paidpaymentAccess.create
                      "
                      bottom
                      dark
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          x-small
                          :disabled="!paidpaymentAccess.create"
                          @click.stop="setPaid(paymentDetailItem)"
                          v-on="on"
                        >
                          <v-icon>mdi-check-decagram</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: white">Payment Received</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:item="{ expand, item, isExpanded, index }">
              <tr
                v-if="item.paidPaymentId"
                :key="index"
                :class="paidItemRow(isExpanded)"
                @click="showPaidPayment(item)"
              >
                <td>
                  <v-btn
                    v-if="!isExpanded"
                    icon
                    x-small
                    @click.stop="expand(true)"
                    ><v-icon small>mdi-chevron-down</v-icon></v-btn
                  >
                  <v-btn
                    v-if="isExpanded"
                    icon
                    x-small
                    @click.stop="expand(false)"
                    ><v-icon small>mdi-chevron-up</v-icon></v-btn
                  >
                </td>
                <td>
                  <p class="caption">{{ item.refNo }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.date }}</p>
                </td>
                <td class="text-overflow">
                  <a class="caption" @click="redirectBed(item)">{{
                    item.tenantName
                  }}</a>
                </td>
                <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
                <td>
                  <p class="caption">{{ item.category }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.period }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.dueDate }}</p>
                </td>
                <td>
                  <p class="caption">{{ formatCurrency(item.total) }}</p>
                </td>
                <td>
                  <p class="caption">{{ formatCurrency(item.amount) }}</p>
                </td>
                <td>
                  <div class="d-flex flex-row">
                    <p :class="statusClass(item.raw_status)">
                      {{ item.status }}
                    </p>
                    <v-tooltip v-if="hasPartialPayments(item)" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" color="warning" x-small v-on="on"
                          >mdi-alert-circle-check</v-icon
                        >
                      </template>
                      <p class="white--text">
                        Contains unpaid partial payments
                      </p>
                    </v-tooltip>
                    <v-tooltip v-if="item.total < item.amount" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" color="success" x-small v-on="on"
                          >mdi-arrow-up-bold-circle-outline</v-icon
                        >
                      </template>
                      <p class="white--text">Overpayment</p>
                    </v-tooltip>
                  </div>
                </td>
                <td>
                  <div v-if="item.raw_status">
                    <div
                      v-if="
                        item.raw_status !== PaidPaymentStatus.PENDING_APPROVAL
                      "
                      class="d-flex flex-row"
                    >
                      <v-tooltip
                        v-if="
                          item.raw_status != PaymentStatus.VOID &&
                          item.raw_status !=
                            PaymentStatus.VOID_CREDIT_BALANCE &&
                          item.raw_status != PaymentStatus.CANCELED &&
                          paidpaymentAccess.void
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            :disabled="!paidpaymentAccess.void"
                            v-on="on"
                            @click.stop="voidPaidPayment(item)"
                          >
                            <v-icon>mdi-cash-remove</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Void Payment</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          item.raw_status != PaymentStatus.VOID &&
                          item.raw_status !=
                            PaymentStatus.VOID_CREDIT_BALANCE &&
                          item.raw_status != PaymentStatus.CANCELED &&
                          paidpaymentAccess.cancel
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="red"
                            :disabled="!paidpaymentAccess.cancel"
                            v-on="on"
                            @click.stop="cancelPaidPayment(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Cancel</span>
                      </v-tooltip>
                    </div>
                    <div v-else class="d-flex flex-row">
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="primary"
                            :disabled="!paidpaymentAccess.approve"
                            v-on="on"
                            @click.stop="approvePaidPayment(item)"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Approve paid payment</span>
                      </v-tooltip>
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="red"
                            :disabled="!paidpaymentAccess.reject"
                            v-on="on"
                            @click.stop="rejectPaidPayment(item.paidPaymentId)"
                          >
                            <v-icon>mdi-cancel</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Reject paid payment</span>
                      </v-tooltip>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-else style="cursor: pointer" @click="showPayment(item)">
                <td></td>
                <td>
                  <p class="caption">{{ item.refNo }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.date }}</p>
                </td>
                <td class="text-overflow">
                  <a class="caption" @click="redirectBed(item)">{{
                    item.tenantName
                  }}</a>
                </td>
                <td>
                  <p class="caption">{{ item.category }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.period }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.dueDate }}</p>
                </td>
                <td>
                  <p class="caption">{{ formatCurrency(item.total) }}</p>
                </td>
                <td>
                  <p class="caption">{{ formatCurrency(item.amountPaid) }}</p>
                </td>
                <td>
                  <p :class="statusClass(item.raw_status)">{{ item.status }}</p>
                </td>
                <td>
                  <div v-if="item.raw_status">
                    <div
                      v-if="item.raw_status !== PaymentStatus.PENDING_APPROVAL"
                      class="d-flex flex-row"
                    >
                      <!-- TODO: refactor all the other actions to use action-button -->
                      <action-button
                        :activate-condition="
                          (item.raw_status === PaymentStatus.PENDING ||
                            item.raw_status === PaymentStatus.PAID_PARTIAL) &&
                          paidpaymentAccess.create
                        "
                        :disabled-condition="!paidpaymentAccess.create"
                        title="Payment Received"
                        :action="() => setPaid(item)"
                        icon="mdi-check-decagram"
                        color="primary"
                      ></action-button>
                      <v-tooltip
                        v-if="
                          item.raw_status === PaymentStatus.PENDING &&
                          paymentrequestAccess.update
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="
                              !paymentrequestAccess.update || item.readonly
                            "
                            @click.stop="updatePayment(item)"
                            v-on="on"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Update Payment</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          ![
                            PaymentStatus.VOID,
                            PaymentStatus.VOID_CREDIT_BALANCE,
                            PaymentStatus.CANCELED,
                            PaymentStatus.POSTDATED
                          ].includes(item.raw_status) &&
                          paymentrequestAccess.void
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            :disabled="
                              !paymentrequestAccess.void || item.readonly
                            "
                            v-on="on"
                            @click.stop="voidPayment(item)"
                          >
                            <v-icon>mdi-cash-remove</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Void Payment</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          ![
                            PaymentStatus.VOID,
                            PaymentStatus.VOID_CREDIT_BALANCE,
                            PaymentStatus.CANCELED,
                            PaymentStatus.POSTDATED
                          ].includes(item.raw_status) &&
                          paymentrequestAccess.cancel
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="red"
                            :disabled="
                              !paymentrequestAccess.cancel || item.readonly
                            "
                            v-on="on"
                            @click.stop="cancelPayment(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Cancel</span>
                      </v-tooltip>
                    </div>
                    <div v-else class="d-flex flex-row">
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="primary"
                            :disabled="!paymentrequestAccess.approve"
                            v-on="on"
                            @click.stop="approvePaymentRequest(item)"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white"
                          >Approve payment request</span
                        >
                      </v-tooltip>
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="error"
                            :disabled="!paymentrequestAccess.reject"
                            v-on="on"
                            @click.stop="rejectPaymentRequest(item.paymentId)"
                          >
                            <v-icon>mdi-cancel</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Reject payment request</span>
                      </v-tooltip>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <!-- Payments Mobile View -->
          <v-data-table
            class="denser"
            :headers="headers"
            :items="payments"
            :options.sync="options"
            :server-items-length="total"
            item-key="refNo"
            :loading="loading"
            loading-text="Loading... Please wait"
            no-data-text="All Payments and Transactions will appear here."
            multi-sort
            :footer-props="{ 'items-per-page-options': [5] }"
            dense
            :expanded.sync="expandedPayments"
            disable-sort
          >
            <template v-slot:expanded-item="{ headers, item }">
              <v-divider></v-divider>
              <tr
                v-for="(paymentDetailItem, index) in item.payment_details"
                :key="`expand_${index}__${generateId()}`"
                :class="expandedItemRow(index, item.payment_details)"
                @click="showPayment(paymentDetailItem)"
              >
                <div
                  class="d-flex flex-column pl-5 py-2"
                  @click="togglePaymentMobile(item)"
                >
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="font-weight-bold body-2">
                        {{ paymentDetailItem.category }}
                      </p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="font-weight-bold body-2">
                        {{ formatCurrency(paymentDetailItem.amountPaid) }}
                      </p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption font-weight-bold">TOTAL</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">
                        {{ formatCurrency(paymentDetailItem.total) }}
                      </p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">{{ paymentDetailItem.tenantName }}</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">{{ paymentDetailItem.bedName }}</p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">
                        Status:
                        <span :class="statusClass(item.raw_status)">{{
                          item.status
                        }}</span>
                      </p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <v-tooltip
                        v-if="
                          paymentDetailItem.raw_status &&
                          (paymentDetailItem.raw_status ===
                            PaymentStatus.PENDING ||
                            paymentDetailItem.raw_status ===
                              PaymentStatus.PAID_PARTIAL) &&
                          paidpaymentAccess.create
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="!paidpaymentAccess.create"
                            @click.stop="setPaid(paymentDetailItem)"
                            v-on="on"
                          >
                            <v-icon>mdi-check-decagram</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Payment Received</span>
                      </v-tooltip>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">{{ paymentDetailItem.period }}</p>
                    </v-col>
                  </div>
                </div>
              </tr>
            </template>
            <template v-slot:item="{ expand, item, isExpanded, index }">
              <v-divider></v-divider>
              <tr
                v-if="item.paidPaymentId"
                :key="index"
                :class="paidItemRow(isExpanded)"
                @click="showPaidPayment(item)"
              >
                <div
                  class="d-flex flex-column py-2"
                  @click.stop="togglePaymentMobile(item)"
                >
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="font-weight-bold body-2">{{ item.category }}</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="font-weight-bold body-2">
                        {{ formatCurrency(item.amount) }}
                      </p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption font-weight-bold">TOTAL</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">{{ formatCurrency(item.total) }}</p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">{{ item.tenantName }}</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">{{ item.bedName }}</p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0 d-flex flex-row">
                      <p class="caption">
                        Status:
                        <span :class="statusClass(item.raw_status)">{{
                          item.status
                        }}</span>
                      </p>
                      <v-tooltip v-if="hasPartialPayments(item)" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon class="ml-1" color="warning" x-small v-on="on"
                            >mdi-alert-circle-check</v-icon
                          >
                        </template>
                        <p class="white--text">
                          Contains unpaid partial payments
                        </p>
                      </v-tooltip>
                      <v-tooltip v-if="item.total < item.amount" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon class="ml-1" color="success" x-small v-on="on"
                            >mdi-arrow-up-bold-circle-outline</v-icon
                          >
                        </template>
                        <p class="white--text">Overpayment</p>
                      </v-tooltip>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <div class="d-flex flex-row justify-space-between">
                        <div v-if="item.raw_status">
                          <div
                            v-if="
                              item.raw_status !==
                              PaidPaymentStatus.PENDING_APPROVAL
                            "
                            class="d-flex flex-row"
                          >
                            <p class="caption">{{ item.period }}</p>
                            <v-tooltip
                              v-if="
                                item.raw_status != PaymentStatus.VOID &&
                                item.raw_status !=
                                  PaymentStatus.VOID_CREDIT_BALANCE &&
                                item.raw_status != PaymentStatus.CANCELED &&
                                paidpaymentAccess.void
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  :disabled="!paidpaymentAccess.void"
                                  v-on="on"
                                  @click.stop="voidPaidPayment(item)"
                                >
                                  <v-icon>mdi-cash-remove</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Void Payment</span>
                            </v-tooltip>
                            <v-tooltip
                              v-if="
                                item.raw_status != PaymentStatus.VOID &&
                                item.raw_status !=
                                  PaymentStatus.VOID_CREDIT_BALANCE &&
                                item.raw_status != PaymentStatus.CANCELED &&
                                paidpaymentAccess.cancel
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  :disabled="!paidpaymentAccess.cancel"
                                  v-on="on"
                                  @click.stop="cancelPaidPayment(item)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Cancel</span>
                            </v-tooltip>
                          </div>
                          <div v-else class="d-flex flex-row">
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="primary"
                                  :disabled="!paidpaymentAccess.approve"
                                  v-on="on"
                                  @click.stop="approvePaidPayment(item)"
                                >
                                  <v-icon>mdi-check</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Approve paid payment</span
                              >
                            </v-tooltip>
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  :disabled="!paidpaymentAccess.reject"
                                  v-on="on"
                                  @click.stop="
                                    rejectPaidPayment(item.paidPaymentId)
                                  "
                                >
                                  <v-icon>mdi-cancel</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Reject paid payment</span
                              >
                            </v-tooltip>
                          </div>
                        </div>
                        <div class="d-flex flex-row align-end">
                          <v-icon> {{ togglePaymentMobileIcon }} </v-icon>
                        </div>
                      </div>
                    </v-col>
                  </div>
                </div>
              </tr>
              <tr
                v-else
                style="cursor: pointer"
                class="tr-head"
                @click="showPayment(item)"
              >
                <div class="d-flex flex-column py-2">
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="font-weight-bold body-2">
                        {{ item.category }}
                      </p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="font-weight-bold body-2">
                        {{ formatCurrency(item.amountPaid) }}
                      </p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption font-weight-bold">TOTAL</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">{{ formatCurrency(item.total) }}</p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">{{ item.tenantName }}</p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <p class="caption">{{ item.bedName }}</p>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">
                        Status:
                        <span :class="statusClass(item.raw_status)">{{
                          item.status
                        }}</span>
                      </p>
                    </v-col>
                    <v-col class="pa-0" align="end">
                      <div v-if="item.raw_status">
                        <div
                          v-if="
                            item.raw_status !== PaymentStatus.PENDING_APPROVAL
                          "
                          class="d-flex flex-row justify-end"
                        >
                          <v-tooltip
                            v-if="
                              (item.raw_status === PaymentStatus.PENDING ||
                                item.raw_status ===
                                  PaymentStatus.PAID_PARTIAL) &&
                              paidpaymentAccess.create
                            "
                            bottom
                            dark
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                color="primary"
                                x-small
                                :disabled="!paidpaymentAccess.create"
                                @click.stop="setPaid(item)"
                                v-on="on"
                              >
                                <v-icon>mdi-check-decagram</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white">Payment Received</span>
                          </v-tooltip>
                          <v-tooltip
                            v-if="
                              item.raw_status === PaymentStatus.PENDING &&
                              paymentrequestAccess.update
                            "
                            bottom
                            dark
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                color="primary"
                                x-small
                                :disabled="
                                  !paymentrequestAccess.update || item.readonly
                                "
                                @click.stop="updatePayment(item)"
                                v-on="on"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white">Update Payment</span>
                          </v-tooltip>
                          <v-tooltip
                            v-if="
                              ![
                                PaymentStatus.VOID,
                                PaymentStatus.VOID_CREDIT_BALANCE,
                                PaymentStatus.CANCELED,
                                PaymentStatus.POSTDATED
                              ].includes(item.raw_status) &&
                              paymentrequestAccess.void
                            "
                            bottom
                            dark
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                x-small
                                :disabled="
                                  !paymentrequestAccess.void || item.readonly
                                "
                                v-on="on"
                                @click.stop="voidPayment(item)"
                              >
                                <v-icon>mdi-cash-remove</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white">Void Payment</span>
                          </v-tooltip>
                          <v-tooltip
                            v-if="
                              ![
                                PaymentStatus.VOID,
                                PaymentStatus.VOID_CREDIT_BALANCE,
                                PaymentStatus.CANCELED,
                                PaymentStatus.POSTDATED
                              ].includes(item.raw_status) &&
                              paymentrequestAccess.cancel
                            "
                            bottom
                            dark
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                x-small
                                color="red"
                                :disabled="
                                  !paymentrequestAccess.cancel || item.readonly
                                "
                                v-on="on"
                                @click.stop="cancelPayment(item)"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white">Cancel</span>
                          </v-tooltip>
                        </div>
                        <div v-else class="d-flex flex-row justify-end">
                          <v-tooltip bottom dark>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                x-small
                                color="primary"
                                :disabled="!paymentrequestAccess.approve"
                                v-on="on"
                                @click.stop="approvePaymentRequest(item)"
                              >
                                <v-icon>mdi-check</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white"
                              >Approve payment request</span
                            >
                          </v-tooltip>
                          <v-tooltip bottom dark>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                x-small
                                color="error"
                                :disabled="!paymentrequestAccess.reject"
                                v-on="on"
                                @click.stop="
                                  rejectPaymentRequest(item.paymentId)
                                "
                              >
                                <v-icon>mdi-cancel</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white"
                              >Reject payment request</span
                            >
                          </v-tooltip>
                        </div>
                      </div>
                    </v-col>
                  </div>
                  <div class="d-flex flex-row">
                    <v-col class="pa-0">
                      <p class="caption">{{ item.period }}</p>
                    </v-col>
                  </div>
                </div>
              </tr>
            </template>
          </v-data-table>
        </div>

        <div
          v-if="!mobile"
          class="table-footer-prepend d-flex pl-2 align-center"
        >
          <v-btn
            v-if="allExpanded"
            text
            small
            color="primary"
            @click="collapseAll"
            ><v-icon class="mr-1" small>mdi-unfold-less-horizontal</v-icon
            >Collapse all</v-btn
          >
          <v-btn v-else text small color="primary" @click="expandAll"
            ><v-icon class="mr-1" small>mdi-unfold-more-horizontal</v-icon
            >Expand all</v-btn
          >
        </div>
      </v-card>
      <v-skeleton-loader
        v-show="loading"
        ref="skeleton"
        type="table"
        loading
        class="mx-auto"
      ></v-skeleton-loader>
    </v-container>
    <Invoice ref="invoice"></Invoice>
    <ConfirmPayment ref="confirmPayment"></ConfirmPayment>
    <VoidPayment ref="voidPayment"></VoidPayment>
    <VoidPaidPayment ref="voidPaidPayment"></VoidPaidPayment>
    <CancelPayment ref="cancelPayment"></CancelPayment>
    <CancelPaidPayment ref="cancelPaidPayment"></CancelPaidPayment>
    <!-- <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
    <GenerateReport ref="generateReport"></GenerateReport>
    <CreateMultiplePayments
      ref="createMultiplePayments"
    ></CreateMultiplePayments>
    <UpdatePaymentRequest ref="updatePaymentRequest"></UpdatePaymentRequest>
    <ApprovePaymentRequest ref="approvePaymentRequest"></ApprovePaymentRequest>
    <ApprovePaidPayment ref="approvePaidPayment"></ApprovePaidPayment>
    <paid-payment-invoice ref="paidPaymentInvoice"></paid-payment-invoice>
  </div>
</template>

<script>
import Invoice from '../../components/Invoice.vue'
import ConfirmPayment from '../../components/payment/ConfirmPayment.vue'
import VoidPayment from '../../components/payment/VoidPayment.vue'
import VoidPaidPayment from '../../components/payment/VoidPaidPayment.vue'
import CancelPayment from '../../components/payment/CancelPayment.vue'
import CancelPaidPayment from '../../components/payment/CancelPaidPayment.vue'
import GenerateReport from '../../components/payment/GenerateReport.vue'
import CreateMultiplePayments from '../../components/payment/CreateMultiplePayments.vue'
import UpdatePaymentRequest from '../../components/units/UpdatePaymentRequest.vue'
import ApprovePaymentRequest from '../../components/payment/ApprovePaymentRequest.vue'
import ApprovePaidPayment from '../../components/payment/ApprovePaidPayment.vue'
import ActionButton from '../../components/ActionButton.vue'
import PaidPaymentInvoice from '../../components/payment/PaidPaymentInvoice.vue'

import Hashids from 'hashids'
import { nanoid } from 'nanoid/non-secure'
import {
  paymentStatusSelect,
  PaymentStatus,
  PaymentCategories,
  PaidPaymentStatus
} from '../../config/payment'
const hashids = new Hashids()

export default {
  components: {
    Invoice,
    ConfirmPayment,
    VoidPayment,
    CancelPayment,
    CancelPaidPayment,
    GenerateReport,
    CreateMultiplePayments,
    UpdatePaymentRequest,
    VoidPaidPayment,
    ApprovePaymentRequest,
    ApprovePaidPayment,
    ActionButton,
    PaidPaymentInvoice
  },
  data() {
    return {
      searchString: '',
      loading: true,
      limit: 0,
      total: 0,
      options: {},
      dialog: false,
      item: {},
      pageCount: 0,
      propertyTags: [],
      selectedTags: [],
      statusItems: paymentStatusSelect,
      selectedCategories: [],
      categories: [],
      progressMsg: '',
      expandedPayments: [],
      allExpanded: false,
      togglePaymentMobileIcon: 'mdi-chevron-down',
      PaymentStatus,
      PaymentCategories,
      selectedStatuses: [],
      PaidPaymentStatus
    }
  },
  computed: {
    payments() {
      return this.$store.getters['payments/getPayments']
    },
    headers() {
      return this.$store.getters['payments/getHeaders']
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    allCategoriesSelected() {
      return (
        this.selectedCategories.length ===
        (this.categories && this.categories.length)
      )
    },
    someCategoriesSelected() {
      return this.selectedCategories.length > 0 && !this.allCategoriesSelected
    },
    allTagsSelected() {
      return (
        this.selectedTags.length ===
        (this.propertyTags && this.propertyTags.length)
      )
    },
    someTagsSelected() {
      return this.selectedTags.length > 0 && !this.allTagsSelected
    },
    iconCategories() {
      if (this.allCategoriesSelected) return 'mdi-close-box'
      if (this.someCategoriesSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconStatuses() {
      if (this.allStatusesSelected) return 'mdi-close-box'
      if (this.someStatusesSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allStatusesSelected() {
      return (
        this.selectedStatuses.length ===
        (this.statusItems && this.statusItems.length)
      )
    },
    someStatusesSelected() {
      return this.selectedStatuses.length > 0 && !this.allStatusesSelected
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    },
    paymentrequestAccess() {
      return this.$root.$roleAccess('paymentrequest').access
    },
    paidpaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    options: {
      async handler() {
        await this.searchAction()
      }
    }
  },
  async mounted() {
    this.loading = true
    this.$socket.client.emit('init', this.user.userId)
    await this.loadCategories()
    await this.reload()
    this.loading = false
  },
  methods: {
    async reload() {
      this.loading = true
      await this.loadCategories()
      this.selectedCategories = this.categories.slice().map((t) => t.value)
      this.selectedStatuses = this.statusItems.slice().map((t) => t.value)
      this.propertyTags = this.property.tags

      await this.searchAction()

      if (this.allExpanded) {
        this.expandedPayments = this.payments
      } else {
        this.expandedPayments = []
      }
    },
    async loadCategories() {
      let categories = await this.$store.getters['properties/getProperty']
        .payment_categories_details[0].categories
      this.categories = [...categories] //shallow copy so that the 'push' line below doesn't modify the categories in the property store
      this.categories.push({ text: 'Deleted', value: 'deleted' })
    },
    showPayment(item) {
      if (this.$refs.invoice) this.$refs.invoice.open({ item: item })
    },
    showPaidPayment(item) {
      if (this.$refs.paidPaymentInvoice)
        this.$refs.paidPaymentInvoice.open({ item })
    },
    test(props) {
      //eslint-disable-next-line
      console.log(props)
    },
    async setPaid(item) {
      this.$refs.confirmPayment.open(item).then(() => {
        this.reload()
      })
    },
    async searchAction() {
      // prevent empty calls
      if (
        !this.selectedCategories.length > 0 &&
        !this.selectedStatuses.length > 0
      ) {
        return
      }
      this.loading = true
      await this.$store
        .dispatch('payments/fetchPaymentsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.selectedStatuses || [],
          categories: this.selectedCategories,
          tags: this.selectedTags
        })
        .then((data) => {
          this.loading = false
          this.limit = data.limit
          this.total = data.count
        })
    },
    // print() {
    //   this.d.print(this.$refs.invoice.$el, [cssText])
    // },
    redirectBed(params) {
      const { bedId, username } = params
      // this.$router.push(`/user/${tenant.username}`)
      if (bedId != null) this.$router.push(`/bed/${hashids.encode(bedId)}`)
      else this.$router.push(`/user/${username}`)
    },
    voidPayment(item) {
      this.$refs.voidPayment.open(item).then(() => {
        this.reload()
      })
    },
    cancelPayment(item) {
      this.$refs.cancelPayment.open(item).then(() => {
        this.reload()
      })
    },
    openGenerateReportDialog() {
      this.$refs.generateReport.open()
    },
    selectAllCategories() {
      if (this.allCategoriesSelected) {
        this.selectedCategories = []
      } else {
        this.selectedCategories = this.categories.slice().map((t) => t.value)
      }
    },
    selectAllStatuses() {
      if (this.allStatusesSelected) {
        this.selectedStatuses = []
      } else {
        this.selectedStatuses = this.statusItems.slice().map((t) => t.value)
      }
    },
    selectAllCategoriesAndReload() {
      this.$nextTick(async () => {
        this.selectAllCategories()
        await this.searchAction()
      })
    },
    selectAllTags() {
      this.$nextTick(() => {
        if (this.allTagsSelected) {
          this.selectedTags = []
        } else {
          this.selectedTags = this.propertyTags.slice().map((t) => t.value)
        }
        this.searchAction()
      })
    },
    iconSelected(all, some) {
      if (all) return 'mdi-close-box'
      if (some) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllStatusesAndReload() {
      this.$nextTick(async () => {
        this.selectAllStatuses()
        await this.searchAction()
      })
    },
    async openCreateMultiplePaymentsDialog() {
      const success = await this.$refs.createMultiplePayments.open()
      if (success) {
        // this.$root.$setLoading(true)
        // this.progressMsg = `Processing CSV File...`
        this.$router.replace('/preview-multiple-payments')
      }
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    async updatePayment(item) {
      this.$refs.updatePaymentRequest.open(item).then(async () => {
        this.loading = true
        await this.searchAction()
      })
    },
    statusClass(status) {
      if (
        [PaymentStatus.PENDING, PaymentStatus.PENDING_APPROVAL].includes(status)
      ) {
        return 'red--text caption'
      } else {
        return 'caption'
      }
    },
    paidItemRow(isExpanded) {
      if (isExpanded) return 'row-item-expanded'
      else return
    },
    expandedItemRow(index, items) {
      // if(index === 0) return 'expand-item'
      if (index >= items.length - 1) return 'expand-item bottom-border'
      return 'expand-item'
    },
    cancelPaidPayment(item) {
      this.$refs.cancelPaidPayment.open(item).then(() => {
        this.reload()
      })
    },
    voidPaidPayment(item) {
      this.$refs.voidPaidPayment.open(item).then(() => {
        this.reload()
      })
    },
    paymentDetailItemAmountPaid(payment, paidPaymentId) {
      const items = payment.paidItems || []
      return (
        items
          .filter((item) => item.paidPaymentId === paidPaymentId)
          .reduce((a, b) => a + b.amount, 0) ||
        payment.amountPaid ||
        0
      )
    },
    togglePaymentMobile(payment) {
      if (this.expandedPayments.length > 0) {
        this.expandedPayments = []
        this.togglePaymentMobileIcon = 'mdi-chevron-down'
      } else {
        this.expandedPayments = [payment]
        this.togglePaymentMobileIcon = 'mdi-chevron-up'
      }
    },
    expandAll() {
      this.expandedPayments = this.payments
      this.allExpanded = true
    },
    collapseAll() {
      this.expandedPayments = []
      this.allExpanded = false
    },
    generateId() {
      return nanoid(5)
    },
    hasPartialPayments(item) {
      return item.payment_details.some((p) => p.status === 'Partial Payment')
    },
    approvePaymentRequest(payment) {
      this.$refs.approvePaymentRequest.open(payment).then(() => {
        this.reload()
      })
    },
    rejectPaymentRequest(paymentId) {
      this.$root
        .$confirm({
          title: 'Reject payment request',
          message: 'Are you sure you want to reject the payment request?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaymentRequestAction', {
              paymentId
            })
            await this.reload()
          }
        })
    },
    approvePaidPayment(paidPayment) {
      this.$refs.approvePaidPayment.open(paidPayment).then(() => {
        this.reload()
      })
    },
    rejectPaidPayment(paidPaymentId) {
      this.$root
        .$confirm({
          title: 'Reject payment',
          message: 'Are you sure you want to reject the payment?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaidPaymentAction', {
              paidPaymentId
            })
            await this.reload()
          }
        })
    }
  },
  sockets: {
    multiplePaymentsProgress(data) {
      const dataObj = JSON.parse(data)
      if (!dataObj.done) {
        this.progressMsg = `Creating multiple payments from CSV... (${dataObj.index}/${dataObj.count})`
      } else {
        this.progressMsg = ``
        this.$root.$setLoading(false)
      }
    }
  }
}
</script>

<style scoped>
table thead tr th {
  white-space: nowrap !important;
}
.card-container {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
.text-overflow {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-item-expanded td p {
  font-weight: bold;
}
.row-item-expanded td {
  border: none !important;
}
.expand-item td p {
  font-weight: 300;
  font-size: 11px !important;
}
.expand-item td {
  border: none !important;
}
tr.bottom-border td {
  /*border-bottom: thin solid #CCC !important;*/
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.table-footer-prepend {
  margin-top: -54px;
  height: 48px;
}
.test {
  border: 2px solid yellow;
}
</style>
